/**
 * All reusable Custom* components in one import:
 *
 *   import { CustomInputField, CustomDropdowns, CustomButton } from "../../Component/customComponents";
 *
 * Colours, borders, radius and sizes for all of them live in
 * ./CustomTheme/customTheme.css — change a value there to restyle everything.
 */

// ---- form ----
export { default as CustomFormField, getFieldIds } from "./CustomFormField/CustomFormField";
export { default as CustomInputField } from "./CustomInputFields/CustomInputField";
export { default as CustomTextArea } from "./CustomTextArea/CustomTextArea";
export { default as CustomDropdowns } from "./CustomDropdowns/CustomDropdowns";
export { default as CustomDatePicker } from "./CustomDatePicker/CustomDatePicker";
export { default as CustomFileUpload, validateFile, validateFileContent } from "./CustomFileUpload/CustomFileUpload";
export { default as CustomCheckbox } from "./CustomCheckbox/CustomCheckbox";
export { default as CustomRadioGroup } from "./CustomRadioGroup/CustomRadioGroup";
export { default as CustomToggleSwitch } from "./CustomToggleSwitch/CustomToggleSwitch";
export { default as CustomRichTextEditor } from "./CustomRichTextEditor/CustomRichTextEditor";
export { default as CustomButton } from "./CustomButton/CustomButton";
export { default as CustomIconButton } from "./CustomIconButton/CustomIconButton";

// ---- brand icons (lucide has no brand logos) ----
export { WhatsAppLogo } from "./CustomIcons/BrandIcons";

// ---- data ----
export {
  default as CustomAdminTable,
  RowActions,
  ViewAction,
  EditAction,
  DeleteAction,
  renderStatus,
  CustomFilterButton,
  useHeaderFilterButton,
} from "./CustomAdminTable/CustomAdminTable";
export { default as CustomStatCard } from "./CustomStatCard/CustomStatCard";
export { default as CustomSummaryCard, CustomSummaryCards } from "./CustomSummaryCard/CustomSummaryCard";
export { default as CustomBadge, getStatusTone } from "./CustomBadge/CustomBadge";
export { default as CustomCountChip } from "./CustomCountChip/CustomCountChip";
export { default as CustomEmptyState } from "./CustomEmptyState/CustomEmptyState";

// ---- overlay ----
export { default as CustomModal } from "./CustomModal/CustomModal";
export { default as CustomConfirmDialog } from "./CustomConfirmDialog/CustomConfirmDialog";

// ---- layout ----
export { default as CustomPageLayout } from "./CustomPageLayout/CustomPageLayout";
